import { DefaultService } from '@/services/DefaultService';

export default class FormRespostaCabecalhoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(formRespostaCabecalho, contexto = "pro") {
        return this._http.post(`${this._env}/ven/formRespostaCabecalho`, formRespostaCabecalho, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    finalizar(uuid) {
        return this._http.post(`${this._env}/ven/formRespostaCabecalho/${uuid}/finalizar`, {},  this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
}